module.exports = __webpack_public_path__ + "img/especiais.5c62b831.svg";